import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { format } from "date-fns";
import React, { useEffect,useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalEmptyPage from "../../common/GlobalEmptyPage/GlobalEmptyPage";
import TableLoaderSkeleton from "../../global/Loader/TableLoaderSkeleton";
import GlobalTablePagination from "../../global/Pagination/GlobalTablePagination";
import { USER_STATUS } from "../../helpers/constant/coreConstant";
import { getFullName } from "../../helpers/utils/getFullName";
import { selectJobSeekerState } from "../../state/jobSeeker/jobSeekerSelector";
import { getJobSeekersData } from "../../state/jobSeeker/jobSeekerSlice";
import JobSeekerHeader from "./JobSeekerHeader";
import JsMenuAction from "./JsMenuAction";

const headCells = [
  {
    id: "Name",
    label: "Name",
  },
  {
    id: "Email",
    label: "Email",
  },
  {
    id: "Country",
    label: "Country",
  },
  {
    id: "phone",
    label: "Phone",
  },
  {
    id: "linkedin",
    label: "Linkedin",
  },
  {
    id: "Joining Date",
    label: "Joining Date",
  },
  {
    id: "Status",
    label: "Status",
  },
  {
    id: "Actions",
    label: "Actions",
  },
];

const TableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.id} align="left" padding={"normal"}>
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const JobSeeker = () => {
  const dispatch = useDispatch();
  const { data: jobSeekerList, isLoading, page, perPage, count,searchKey } = useSelector(selectJobSeekerState);
  useEffect(() => {
    dispatch(getJobSeekersData({ page: 1, perPage: perPage, searchKey }));
  }, [dispatch, perPage, searchKey]);

  const onChangePage = (newPage) => {
    dispatch(getJobSeekersData({ page: newPage, perPage: perPage, searchKey }));
  };

  const onChangePerPage = (perPage, newPage) => {
    dispatch(getJobSeekersData({ page: newPage, perPage: perPage ,searchKey}));
  };

  let content = null;
  if (isLoading) {
    content = <TableLoaderSkeleton columns={4} numberOfRows={10} />;
  } else if (jobSeekerList?.length === 0) {
    content = <GlobalEmptyPage title={"No job seeker found!"} />;
  } else if (jobSeekerList?.length > 0) {
    content = (
      <>
        <TableContainer>
          <Table sx={{ minWidth: 750 }}>
            <TableHeader />
            <TableBody>
              {jobSeekerList.map((jobSeeker) => {
                const { id, email, createdAt, status, externalLinks, country, phone } = jobSeeker || {};
                const joiningData = format(new Date(createdAt), "MMM dd, yyyy");
                const links = externalLinks ? JSON.parse(externalLinks) : {};
                return (
                  <TableRow key={id} hover>
                    <TableCell align="left" style={{ width: "24rem" }}>
                      {getFullName(jobSeeker.firstName, jobSeeker.lastName) || "-"}
                    </TableCell>
                    <TableCell align="left">{email || "-"}</TableCell>
                    <TableCell align="left" style={{ width: "24rem" }}>
                      {country || "-"}
                    </TableCell>
                    <TableCell align="left" style={{ width: "24rem" }}>
                      {phone || "-"}
                    </TableCell>
                    <TableCell align="left" style={{ width: "24rem" }}>
                      {links.linkedin ? (
                        <a href={links.linkedin} target="_blank" rel="noopener noreferrer">
                          LinkedIn
                        </a>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell align="left">{joiningData}</TableCell>
                    <TableCell align="left">
                      <Chip label={USER_STATUS.ACTIVE === status ? "Active" : "Blocked"} color={status === 0 ? "warning" : "success"} />
                    </TableCell>
                    <TableCell align="left">
                      <JsMenuAction jobSeeker={jobSeeker} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <GlobalTablePagination count={count} page={page} rowsPerPage={perPage} onChangePerPage={onChangePerPage} onChangePage={onChangePage} />
      </>
    );
  }

  return (
    <>
      <Paper elevation={0}>
        <JobSeekerHeader  />
        {content}
      </Paper>
    </>
  );
};
export default JobSeeker;
